import { buildClientHistoryListRequest } from "services/clientHistoryRequest";

// Page numbers identify a continuation, not a different list. The canonical
// request body preserves client, selected record and limit across legacy URLs.
export const clientHistoryQueryKey = (args) => {
  const body = buildClientHistoryListRequest("", args).body;
  // Both history endpoints default to ten and include that limit in next URLs.
  // An omitted first-page limit and an explicit continuation limit are equal.
  return JSON.stringify({ ...body, limit: body.limit || 10 });
};

export const beginClientHistoryRequest = (state, action) => {
  const clientId = Number(action.meta.arg?.client_id) || null;
  const queryKey = clientHistoryQueryKey(action.meta.arg);
  const clientChanged = state.listClientId !== clientId;
  if (clientChanged || state.listQueryKey !== queryKey) state.isListView = [];
  state.listClientId = clientId;
  state.listQueryKey = queryKey;
  state.listRequestId = action.meta.requestId;
  return clientChanged;
};

export const ownsClientHistoryRequest = (state, action) =>
  state.listRequestId === action.meta.requestId
  && state.listClientId === (Number(action.meta.arg?.client_id) || null)
  && state.listQueryKey === clientHistoryQueryKey(action.meta.arg);
